// src/router/empresa.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']

const empresaBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Empresas',
        to: 'NovaEmpresaList'
    }
]

export default [
    {
        path: '/empresa',
        name: 'NovaEmpresaList',
        component: () => import('@/views/Empresa/ListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Empresas',
            breadcrumb: empresaBreadCrumb
        },
    },
    {
        path: '/empresa/novo',
        name: 'NovaEmpresa',
        component: () => import('@/views/Empresa/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Empresa',
            breadcrumb: [
                ...empresaBreadCrumb,
                {
                    label: 'Nova Empresa',
                    to: 'NovaEmpresa'
                }
            ]
        }
    },
    {
        path: '/empresa/:id/edit',
        name: 'NovaEmpresaEdit',
        component: () => import('@/views/Empresa/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Empresa',
            breadcrumb: [
                ...empresaBreadCrumb,
                {
                    label: 'Detalhes da Empresa',
                    to: 'NovaEmpresa'
                }
            ]
        }
    }
];
